var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.766 16.957",
    stroke: "#263360",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,18.995A2,2,0,0,1,5.995,17H16.766",
    transform: "translate(0 -3.032)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.995,2H16.766V17.957H5.995A2,2,0,0,1,4,15.963V3.995A2,2,0,0,1,5.995,2Z",
    fill: "none"
  }))));
};
export default SvgBook;